import { IServices } from '@/modules/Auth/classes/Clinic'

export const serviceBySpeciality: Record<string, keyof IServices> = {
  ASSISTENTE_SOCIAL: 'servicoAssistenteSocial',
  DENTISTA: 'servicoDentista',
  ENFERMEIRO: 'servicoEnfermagem',
  FISIOTERAPEUTA: 'servicoFisioterapeuta',
  FONOAUDIOLOGO: 'servicoFonoaudiologo',
  MEDICO: 'servicoMedico',
  NUTRICIONISTA: 'servicoNutricao',
  PSICOLOGO: 'servicoPsicologia',
  PSICOLOGO_VIVA: 'servicoPsicologiaViva',
  EDUCADOR_FISICO: 'servicoEducadorFisico',
} as const

export function getDoctorFirstName(fullName: string): string {
  if (!fullName) return
  const match = fullName.match(/^(Dr\.|Dra\.)\s*/i)
  const title = match ? match[0].trim() : ''
  const nameWithoutTitle = fullName.replace(/^(Dr\.|Dra\.)\s*/i, '')
  return title
    ? `${title} ${nameWithoutTitle.split(' ')[0]}`
    : nameWithoutTitle.split(' ')[0]
}
